import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';

import { PASS_REGEX } from '../ApiUrl';
import { TEXTFIELD, Col, SUBMIT, Axios, toast, PASSWORDFIELD } from '../components';
import { API_FORGOTPASSWORD, API_RESETPASSWORD } from '../ApiUrl';

const ForgetPassword = ({ t, changeView }) => {
  const [OTP, setOTP] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showReset, setShowReset] = useState(false);

  function forgot(e) {
    e.preventDefault();
    setIsLoading(true);

    Axios.post(API_FORGOTPASSWORD, { email })
      .then((res) => {
        if (res.data.message !== 'OTP Send Successfully') {
          throw new Error(res.data.message);
        }
        toast.success(t('auth.forgot.otpSent'));
        setShowReset(true);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error(`${err}`);
      });
  }

  function reset(e) {
    e.preventDefault();
    setIsLoading(true);

    if (password.length < 1) {
      setIsLoading(false);
      return toast.error(t('auth.forgot.passwordRequired'));
    }
    if (!PASS_REGEX.test(password)) {
      setIsLoading(false);
      return toast.error(t('auth.forgot.passwordInvalid'));
    }
    if (password !== confirmPassword) {
      setIsLoading(false);
      return toast.error(t('auth.forgot.passwordMismatch'));
    }

    Axios.post(API_RESETPASSWORD, { email, password, confirmPassword, OTP })
      .then((res) => {
        if (res.data.message !== 'Password Reset Successfully') {
          throw new Error(res.data.message);
        }
        toast.success(t('auth.forgot.resetSuccess'));
        changeView('signin');
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error(`${err}`);
      });
  }

  return (
    <div className="app-login-content">
      {!showReset ? (
        <form onSubmit={forgot}>
          <h1>{t('auth.forgot.title')}</h1>
          <p>{t('auth.forgot.instruction')}</p>
          <Col xm="12">
            <TEXTFIELD
              label={t('auth.forgot.emailLabel')}
              fullWidth
              name="email"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              errors={{}}
            />
          </Col>
          <Col md="6" xs="12">
            <SUBMIT
              style={{ backgroundColor: 'green', color: 'white' }}
              title={t('auth.forgot.sendOtp')}
              disabled={isLoading}
            />
          </Col>
        </form>
      ) : (
        <form onSubmit={reset}>
          <h1>{t('auth.reset.title')}</h1>
          <p>{t('auth.reset.instruction')}</p>
          <Col xm="12">
            <PASSWORDFIELD
              label={t('auth.reset.password')}
              fullWidth
              name="password"
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              errors={{}}
            />
          </Col>
          <Col xm="12">
            <PASSWORDFIELD
              label={t('auth.reset.confirmPassword')}
              fullWidth
              name="confirmPassword"
              onChange={(e) => setConfirmPassword(e.target.value)}
              value={confirmPassword}
              errors={{}}
            />
          </Col>
          <Col xm="12">
            <TEXTFIELD
              label={t('auth.reset.otp')}
              fullWidth
              name="otp"
              onChange={(e) => setOTP(e.target.value)}
              value={OTP}
              errors={{}}
            />
          </Col>
          <Col>
            <p style={{ color: '#0A7FC1', cursor: 'pointer' }} onClick={() => setShowReset(false)}>
              {t('auth.reset.resend')}
            </p>
          </Col>
          <Col md="6" xs="12">
            <SUBMIT
              style={{ backgroundColor: 'green', color: 'white' }}
              title={t('auth.reset.submit')}
              disabled={isLoading}
            />
          </Col>
        </form>
      )}
    </div>
  );
};

export default withTranslation()(ForgetPassword);
